import { observer } from 'mobx-react-lite';
import { type FC, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

const Overlays: FC = () => {
  return (
    <Suspense fallback={null}>
      <Outlet />
    </Suspense>
  );
};

export default observer(Overlays);
